import React from 'react';

import { BreadcrumbItem, Breadcrumbs } from '@/components/breadcrumbs';

export interface DrawerLayoutProps {
  children: React.ReactNode;
  breadcrumbItems: BreadcrumbItem[];
  breadcrumbActions?: React.ReactNode;
  className?: string;
}

const DrawerLayout = ({ children, breadcrumbItems, breadcrumbActions, className }: DrawerLayoutProps) => {
  return (
    <>
      <Breadcrumbs items={breadcrumbItems} actions={breadcrumbActions} className="px-6" />
      <div className={className}>{children}</div>
    </>
  );
};

export { DrawerLayout };
